// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `::ng-deep .mat-radio-button.mat-accent .mat-radio-inner-circle {
  background-color: #f8a503 !important;
}

::ng-deep.mat-radio-button.mat-accent.mat-radio-checked .mat-radio-outer-circle {
  border-color: #f8a503 !important;
}`, "",{"version":3,"sources":["webpack://./src/app/modules/component/pages/order-statistics/delivery-adres-dialog/delivery-adres-dialog.component.sass"],"names":[],"mappings":"AAAA;EACI,oCAAA;AACJ;;AACA;EACI,gCAAA;AAEJ","sourcesContent":["::ng-deep .mat-radio-button.mat-accent .mat-radio-inner-circle\n    background-color: #f8a503 !important \n\n::ng-deep.mat-radio-button.mat-accent.mat-radio-checked .mat-radio-outer-circle\n    border-color: #f8a503 !important\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
